
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_28823_3342)"}},[_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"64","height":"64"}},[_c('path',{attrs:{"d":"M63.938 63.938V.062H.062v63.876h63.876z","fill":"#fff","stroke":"#fff","stroke-width":".125"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M32.625 35.125v-27.5H61.5V34","stroke":"#56BFC7","stroke-width":"2.133","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('path',{attrs:{"d":"M41.375 17.625H52.75M41.375 26.375H52.75M41.375 35.25H46.5","stroke":"#56BFC7","stroke-width":"2.133","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"b","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"64","height":"64"}},[_c('path',{attrs:{"d":"M0 0h64v64H0V0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#b)","stroke-width":"2.133","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M61.5 46.5a5 5 0 01-5 5H37.625a5 5 0 01-5-5v-1.375M47.25 51.5v10M40.125 61.5H54.5M47.25 2.5v4.125","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.5 31v30.5M7.5 61.5v-18a5 5 0 01-5-5V24.875a5 5 0 015-5h9.202a7.401 7.401 0 015.77 2.766L32.5 35.125","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.5 7.5a5 5 0 1110 0 5 5 0 01-10 0z","stroke":"#fff"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_28823_3342"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    